import React, { useEffect, useState } from "react";

import { observer } from "mobx-react";
import { Col, Row } from "react-bootstrap";

import { BottomsheetDropdown } from "components";
// import AdditionalCards from "./component/addtional-cards/AdditionalCards";
import fetchIncomeLabelBasedOnNeed from "utils/fetchIncomeLabelBasedOnNeed";

const BharatSavingsStar = (props) => {
  const [showOverlay, setShowOverlay] = useState(false);
  const { form, data } = props;
  let productData = data.data;
  console.log("formmm>>",data.data)
  let biResponse = productData.parsedResponse;
  let firstYearResponse = productData.firstYearResponse;
  let coverLabelBaseOnNeed = fetchIncomeLabelBasedOnNeed(data.cardKey);

  useEffect(() => {
    setShowOverlay(productData.fieldChanged);
  }, [productData.fieldChanged]);

  const onHideOverlay = () => {
    setShowOverlay(false);
  };


  return (
    <div className=''>
      {/* <Row className='mt-2 mt-md-4'> */}
        <div className="my-3 my-md-4 mx-0">
          {/* <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("policy-term").label}</div> */}
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("policy-term").label}
            menuList={form.$("policy-term").extra.optionList}
            value={form.$("policy-term").value}
            onSelect={form.$("policy-term").onChange}
            disabled={form.$("policy-term").disabled}
          />
          {/* </div> */}
        </div>
        <div className="my-3 my-md-4  mx-0" >
         
          {/* <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("premium-paying-term").label}</div> */}
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("premium-paying-term").label}
            menuList={form.$("premium-paying-term").extra.optionList}
            value={form.$("premium-paying-term").value}
            disabled={form.$("premium-paying-term").disabled}
            onSelect={form.$("premium-paying-term").onChange}
          />
        
        </div>
        {/* <Col md={4} className='col-12 mb-3'>
          <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("accrual-of-survival-benefits").label}</div>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("accrual-of-survival-benefits").label}
            menuList={form.$("accrual-of-survival-benefits").extra.optionList}
            value={form.$("accrual-of-survival-benefits").value}
            onSelect={form.$("accrual-of-survival-benefits").onChange}
            disabled={form.$("accrual-of-survival-benefits").disabled}
          />
         
        </Col> */}
      {/* </Row> */}
    </div>
  )
};
export default observer(BharatSavingsStar);